import { render, staticRenderFns } from "./HasilTes.vue?vue&type=template&id=afeeff20&scoped=true"
import script from "./HasilTes.vue?vue&type=script&lang=js"
export * from "./HasilTes.vue?vue&type=script&lang=js"
import style0 from "./HasilTes.vue?vue&type=style&index=0&id=afeeff20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afeeff20",
  null
  
)

export default component.exports